<section class="content head">
  <div class="content-wrapper">
    <mat-card class="login">
      <mat-card-title class="login__header">Login</mat-card-title>
      <form class="login__form" name="form" [formGroup]="loginForm" (submit)="login()" novalidate>
        <mat-form-field class="login__field">
          <input
            matInput
            type="text"
            placeholder="Login"
            formControlName="username"
            class="login__input"
            (blur)="removeLoginError()"/>
          <mat-error *ngIf="username.errors?.required">
            Username is <strong>required</strong>
          </mat-error>
          <mat-error *ngIf="username.errors?.login">
            {{ username.errors?.login }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="login__field">
          <input
            matInput
            type="password"
            placeholder="Password"
            formControlName="password"
            [type]="showPassword ? 'text' : 'password'"
            (blur)="removeLoginError()"/>
          <mat-icon
            matSuffix
            class="login__password-toggle"
            (click)="showPassword = !showPassword">{{ showPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-error *ngIf="password.errors?.required">
            Password is <strong>required</strong>
          </mat-error>
        </mat-form-field>
        <div class="login__actions">
          <div class="login__keep">
            <mat-checkbox formControlName="keep">Keep me logged in</mat-checkbox>
          </div>
          <button mat-raised-button class="login__submit" [color]="'primary'" type="submit">
        <span class="login__submit--logging-in" *ngIf="loggingIn">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </span>
            <span *ngIf="!loggingIn">Login</span>
          </button>
        </div>
      </form>
    </mat-card>
  </div>
</section>
